import {ClickEvent} from "../../../../infrastructure/models/analytics/click-event";

export class BettingContainerDrawerMenuOpenAndCloseClickEvent extends ClickEvent {
  menuLevel: Number;
  screen: String;

  constructor(params: BettingContainerDrawerMenuOpenAndCloseClickEvent) {
    super('', 'click', `menu_${params.eventName}`);

    this.menuLevel = params.menuLevel;
    this.screen = params.screen;
    this.isApostas = true;
  }

  get properties() {
    const properties = super.properties;

    properties.menuLevel = this.menuLevel;
    properties.screen = this.screen
    properties.isApostas = this.isApostas

    return properties;
  }
}